module.exports = __webpack_public_path__ + "img/home-icon.d032df74.svg";